import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../redux/instance/api";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getMemberProfile = createAsyncThunk(
  "member/getMemberProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/user`);

      const status = "success";
      const data = {
        status: status,
        message: response.data,
      };
      return data;
    } catch (error) {
      const status = "error";
      const data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return rejectWithValue(data);
    }
  }
);

export const updateMemberProfile = createAsyncThunk(
  "member/updateMemberProfile",
  async ({ userData, userId }, { rejectWithValue }) => {
    try {
      const payload = {
        imageUrl: userData.imageUrl,
        firstName: userData.firstName,
        lastName: userData.lastName,
        location: userData.location,
        mobile_number: userData.mobile,
        dob: userData.dateOfBirth,
        gender: userData.gender,
        countryCode: userData.countryCode,
        country: userData.country,
        state: userData.state,
        pincode: userData.pincode,
        city: userData.city,
        emergencyContactName: userData.emergencyContactName,
        emergencyContactNumber: userData.emergencyContactNumber,
        emergencyContactRelationship: userData.emergencyContactRelationship,
        departmentIds: userData.departmentIds,
        clientLocationIds: userData.clientLocationIds,
        groupIds: userData.groupIds,
      };

      const response = await api.patch(`/user/${userId}`, payload);

      const status = "success";
      const data = {
        status: status,
        message: response.data,
      };
      return data;
    } catch (error) {
      const status = "error";
      const data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return rejectWithValue(data);
    }
  }
);

const memberProfileSlice = createSlice({
  name: "memberProfile",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMemberProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMemberProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getMemberProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateMemberProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMemberProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateMemberProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });
  },
});

export default memberProfileSlice.reducer;
